import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import jaCommon from '@/locales/ja/common.json';
import jaTop from '@/locales/ja/top.json';
import jaFooter from '@/locales/ja/footer.json';
import jaFaq from '@/locales/ja/faq.json';
import jaPrivacy from '@/locales/ja/privacy.json';
import jaTerms from '@/locales/ja/terms.json';
import jaTos from '@/locales/ja/tos.json';
import jaLogin from '@/locales/ja/login.json';
import jaError404 from '@/locales/ja/error404.json';
import jaSidebar from '@/locales/ja/sidebar.json';
import jaOnboarding from '@/locales/ja/onboarding.json';
import jaReferral from '@/locales/ja/referral.json';
import jaTimePanel from '@/locales/ja/timePanel.json';
import jaActivityCalendar from '@/locales/ja/activityCalendar.json';
import jaSimpleAnalytics from '@/locales/ja/simpleAnalytics.json';
import jaMemo from '@/locales/ja/memo.json';
import jaSearch from '@/locales/ja/search.json';
import jaAnalysis from '@/locales/ja/analysis.json';
import jaPlans from '@/locales/ja/plans.json';
import jaCheckout from '@/locales/ja/checkout.json';
import jaShare from '@/locales/ja/share.json';
import jaScreenshot from '@/locales/ja/screenshot.json';
import jaSettings from '@/locales/ja/settings.json';
import jaMessageForm from '@/locales/ja/messageForm.json';
import enCommon from '@/locales/en/common.json';
import enTop from '@/locales/en/top.json';
import enFooter from '@/locales/en/footer.json';
import enFaq from '@/locales/en/faq.json';
import enPrivacy from '@/locales/en/privacy.json';
import enTerms from '@/locales/en/terms.json';
import enTos from '@/locales/en/tos.json';
import enLogin from '@/locales/en/login.json';
import enError404 from '@/locales/en/error404.json';
import enSidebar from '@/locales/en/sidebar.json';
import enOnboarding from '@/locales/en/onboarding.json';
import enReferral from '@/locales/en/referral.json';
import enTimePanel from '@/locales/en/timePanel.json';
import enActivityCalendar from '@/locales/en/activityCalendar.json';
import enSimpleAnalytics from '@/locales/en/simpleAnalytics.json';
import enMemo from '@/locales/en/memo.json';
import enSearch from '@/locales/en/search.json';
import enAnalysis from '@/locales/en/analysis.json';
import enPlans from '@/locales/en/plans.json';
import enCheckout from '@/locales/en/checkout.json';
import enShare from '@/locales/en/share.json';
import enScreenshot from '@/locales/en/screenshot.json';
import enSettings from '@/locales/en/settings.json';
import enMessageForm from '@/locales/en/messageForm.json';

/**
 * i18n 初期化
 */
void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // リソース
        resources: {
            ja: {
                common: jaCommon,
                top: jaTop,
                footer: jaFooter,
                faq: jaFaq,
                privacy: jaPrivacy,
                terms: jaTerms,
                tos: jaTos,
                login: jaLogin,
                error404: jaError404,
                sidebar: jaSidebar,
                onboarding: jaOnboarding,
                referral: jaReferral,
                timePanel: jaTimePanel,
                activityCalendar: jaActivityCalendar,
                simpleAnalytics: jaSimpleAnalytics,
                memo: jaMemo,
                search: jaSearch,
                analysis: jaAnalysis,
                plans: jaPlans,
                checkout: jaCheckout,
                share: jaShare,
                screenshot: jaScreenshot,
                settings: jaSettings,
                messageForm: jaMessageForm,
            },
            en: {
                common: enCommon,
                top: enTop,
                footer: enFooter,
                faq: enFaq,
                privacy: enPrivacy,
                terms: enTerms,
                tos: enTos,
                login: enLogin,
                error404: enError404,
                sidebar: enSidebar,
                onboarding: enOnboarding,
                referral: enReferral,
                timePanel: enTimePanel,
                activityCalendar: enActivityCalendar,
                simpleAnalytics: enSimpleAnalytics,
                memo: enMemo,
                search: enSearch,
                analysis: enAnalysis,
                plans: enPlans,
                checkout: enCheckout,
                share: enShare,
                screenshot: enScreenshot,
                settings: enSettings,
                messageForm: enMessageForm,
            },
        },
        // 検知できなかった場合の設定言語
        fallbackLng: 'ja',
        // サポートする言語
        supportedLngs: ['ja', 'en'],
        // デフォルトの名前空間
        defaultNS: 'common',
        // 名前空間
        ns: [
            'common',
            'top',
            'footer',
            'faq',
            'privacy',
            'terms',
            'tos',
            'login',
            'error404',
            'sidebar',
            'onboarding',
            'referral',
            'timePanel',
            'activityCalendar',
            'simpleAnalytics',
            'memo',
            'search',
            'analysis',
            'plans',
            'checkout',
            'share',
            'screenshot',
            'settings',
            'messageForm',
        ],
        // インターポレーション
        interpolation: {
            escapeValue: false,
        },
        // 検出方法
        detection: {
            // 検出順序 ブラウザの言語設定 -> HTMLのlang属性
            order: ['navigator', 'htmlTag'],
            // キャッシュを使用しない
            caches: [],
        },
    });

// 検出言語を <html lang> に反映
if (typeof document !== 'undefined') {
    const setHtmlLang = (lng: string) => {
        const lang = (lng || 'en').split('-')[0];
        document.documentElement.setAttribute('lang', lang);
    };
    setHtmlLang(i18n.language);
    i18n.on('languageChanged', setHtmlLang);
}

export default i18n;
